import React from "react";
import moment from "moment";

const DisplayDate = ({date}) => {
  
  const postDate = moment.unix(date).format('ddd MMM DD YYYY kk:mm:ss Z');
  const currentDate = moment(new Date());
  const duration = moment.duration(currentDate.diff(postDate));
  const minutes = (duration.asMinutes() | 0);
  const hours = (duration.asHours() | 0);

  switch (true) {
    case minutes === 0:
      return <p className="gx-text-grey gx-fs-sm gx-mb-0">Just now</p>;
    case minutes < 60:
      return <p className="gx-text-grey gx-fs-sm gx-mb-0">{minutes} min ago</p>;
    case hours < 24:
      return <p className="gx-text-grey gx-fs-sm gx-mb-0">{hours} hours ago</p>;
    default:
      return <p className="gx-text-grey gx-fs-sm gx-mb-0">{moment.unix(date).format("MMMM DD, YYYY")}</p>
  }
};

export default DisplayDate;
